import { useState } from "react";
import { BellFilled, CloseOutlined } from '@ant-design/icons'
import { Avatar, Badge, Button, Drawer, Empty, List } from "antd"

function Notifications(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, content: 'Racing car sprays burning fuel into crowd.' },
    { id: 2, content: 'Japanese princess to wed commoner.' },
    { id: 3, content: 'Australian walks 100km after outback crash.' },
    { id: 4, content: 'Man charged over missing wedding girl.' },
    { id: 5, content: 'Los Angeles battles huge wildfires.' },
  ]);

  const deleteNotification = (id: number) => {
    setNotifications(notifications.filter(n => n.id !== id))
  }

  return (
    <>
      <Badge dot>
        <Avatar className="notifications" onClick={() => setOpen(true)} shape="square" icon={<BellFilled />} />
      </Badge>
      <Drawer extra={<Button title="Marquer tous comme lu" onClick={() => setNotifications([])} type="link">Marquer tous comme lu</Button>} title="Notifications" onClose={() => setOpen(false)} open={open}>
        {
          notifications.length > 0 ?
            <List
              dataSource={notifications}
              renderItem={(item) => (
                <List.Item key={item.id} actions={[<Button key={item.id} type="link" onClick={() => deleteNotification(item.id)}><CloseOutlined /></Button>]} >
                  {item.content}
                </List.Item>
              )}
            />
            :
            <Empty description="Il n'y a pas de notifications" />
        }
      </Drawer>
    </>
  )
}

export default Notifications
